/*
 * Jira Ticket:
 * Created Date: Mon, 23rd Mar 2020, 16:45:28 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Datagrid,
  EditButton,
  FunctionField,
  Pagination,
  ReferenceManyField,
  SelectField,
  TextField,
} from 'react-admin';
import { reducedEmploymentRoleOptions } from 'utils/choices';
import { tabbedLayoutDatagrid } from 'styles';
import {
  isSelf,
  isProjectManager,
  getMaximumRole,
  userIsWithinRole,
} from 'utils/roles';
import { PostPagination } from '../../../../Components/CustomPagination/pagination';

const ProjectsField = ({ record }) => {
  const array = record.projects.map(item => `${item.name}`);
  return array.join('; ');
};

const showEditButton = (permissions, userId, record) => {
  const orgId = record.organisation && record.organisation.id;
  const maxRoleLevel = getMaximumRole(permissions, orgId);
  if (!isSelf(userId) && permissions) {
    return (
      isProjectManager(permissions, orgId) &&
      userIsWithinRole({ userRole: record.role, maxRoleLevel })
    );
  }
  return false;
};

const EmploymentTab = ({
  className,
  hasList,
  hasShow,
  hasEdit,
  dispatch,
  formValues,
  permissions,
  ...props
}) => {
  const classes = tabbedLayoutDatagrid();

  return (
    <div className={classes.root}>
      <ReferenceManyField
        reference="Employment"
        target="user"
        filter={{ status: 'ACCEPTED' }}
        perPage={25}
        pagination={<PostPagination />}
        bulkActionButtons={false}
        {...props}
      >
        <Datagrid
          rowClick={(id, basePath, record) => {
            return showEditButton(permissions, props.id, record)
              ? {
                  pathname: `/Employment/${record.id}`,
                  state: {
                    prevLocation: `/User/${props.id}/1`,
                  },
                }
              : null;
          }}
        >
          <TextField
            source="organisation.name"
            label={'resources.User.fields.organisation'}
            sortable={false}
          />
          <SelectField
            source="role"
            label={'resources.User.fields.role'}
            choices={reducedEmploymentRoleOptions}
            sortable={false}
          />
          <FunctionField
            label={'resources.User.fields.projects'}
            render={record =>
              record.projects ? <ProjectsField record={record} /> : 'All'
            }
          />
        </Datagrid>
      </ReferenceManyField>
    </div>
  );
};

export default EmploymentTab;
